<template>
    <div id="mapping-app">   
      <transition name="fade">
              <h2 class="text-center" v-if="loader" style="padding-top:5%;"><center><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></center></h2>
      </transition>
        <div id="mappingSystem">
            <div  id="dmap">
                <section id="displayMap" style="width:100%; height:100%;">
                    <div id="map-canvas" style="height:350px !important; clear:both;"></div>
                </section>
            </div>
        </div><!--Mapping System-->
    </div>
</template>
<script>
import mapSettings from '../../lib/map';
import svg from '../../lib/svg';
//import fb from '../../lib/fb';

//let db = fb.firebaseApp.database();

export default {
  name: 'BusinessListingsMap',
  props: ['ppCategory', 'pzip','pjurisdiction', 'pcategory', 'lob'],
  data() {
    return {
      title: "Mapping System",
      kml : "",
      zipcode:null,
      map:null,
      markers:null,
      loader:true,
      filters:{
        region: null,
        state: null,
        jurisdiction: null,
        megamarket: null,
        zipcode: null,
        zone: null
      },
      reset:false,
      openInfoWindow:"",
    }
  },
  beforeMount(){
    this.loader = true;
  },
  mounted(){
    console.log("LOB COUNT:", this.lob.length);
    this.loader = false;
    //console.log("LOBS:", obj[0].fields.address);
    if(this.pzip == "none"){
      console.log("Load Jurisdiction Map");
      this.loadJurisdictionMap();
    }else{
      //console.log("Load Zipcode Map");
      this.loadZipcodeMap();
    }
     
  },
methods:{
    loadLOBS(lobs){
       for (var i = 1; i < lobs.length; i++){
          let markers = new google.maps.Marker({
            position: new google.maps.LatLng(lobs[i]['fields']['lat'],lobs[i]['fields']['lng']),
            map: this.map,
            icon: 'https://cloud.citytocitymarket.com/_' + lobs[i]['fields']['icon'],
            label: ""
          });
        }
    },
    loadJurisdictionMap(){
        axios.get( zurl +'api/mapping/heatmaps/jurisdiction/?format=json&map=true&name='+this.pjurisdiction).then(response => {
            let res = response.data.results;
            for (var i = 0; i < res.length; i++){
                this.createMap(res[i]);
                this.createKML(res[i]);
            }
        }); 
        this.loadLOBS(JSON.parse(this.lob));
       
    },
    loadZipcodeMap(){
      console.log(zurl +'api/mapping/heatmaps/zipcode/?format=json&name='+ this.pzip);
      axios.get( zurl +'api/mapping/heatmaps/zipcode/?format=json&name='+this.pzip ).then(response => {
        let r = response.data.results[0];
          //console.log("lat: " + r.lat + "lng: " + r.lng);   
        this.map = new google.maps.Map(document.getElementById('map-canvas'), {
            zoom: r.zoom,
            center: new google.maps.LatLng(r.lat, r.lng),
            mapTypeId: 'roadmap',
            styles: mapSettings.style
        });
        
       this.loadLOBS(JSON.parse(this.lob));

        this.createKML(r);

      });
    },
    createMap(r){
       //console.log("lat: " + r.lat + "lng: " + r.lng);
      this.map = new google.maps.Map(document.getElementById('map-canvas'), {
          zoom: r.zoom,
          center: new google.maps.LatLng(r.lat, r.lng),
          mapTypeId: 'roadmap',
          styles: mapSettings.style
      });
    },
    createMarker(r){
      console.log("Markes:", r);
      this.markers = new google.maps.Marker({
          position: new google.maps.LatLng(r.lat,r.lng),
          map: this.map,
          icon: 'https://cloud.citytocitymarket.com/_' + r.icon,
          label: ""
      });

      let contentString = '<div id="content-'+r.id+'">'+
                          '<div id="siteNotice-'+r.id+'"></div>'+
                            '<h2 id="firstHeading-'+r.id+'" class="firstHeading">'+ r.company_name +'</h2>'+
                            '<div class="bodyContent">'+
                              '<p><b>Address:</b> '+ r.address +', '+ r.city +', ' + r.state +', '+r.five_digit_zip+'</p>'+
                              '<p><b>Phone:</b> <a href="tel:'+r.phone+'">'+r.phone+'</a></p>' +
                            '</div>'+
                          '</div>';
     
      let infowindow = new google.maps.InfoWindow({content: contentString });
      
      this.markers.addListener('click', () => {
          console.log(this.markers.position);
          this.map.panTo(this.markers.position);
          infowindow.setContent(contentString); 
          infowindow.open(this.map, this.markers);
      });


    },
    createInfoWindow(r){
      var infowindow = null;
      
      var contentString = '<div id="content">'+
                          '<div id="siteNotice"></div>'+
                            '<h2 id="firstHeading" class="firstHeading">'+ r.company_name +'</h2>'+
                            '<div id="bodyContent"></div>'+
                          '</div>';
     
      infowindow = new google.maps.InfoWindow({
          content: contentString
      });

      this.markers.addListener('click', function() {
        infowindow.close();
        infowindow.open(this.map, this.markers);
      });
    },
    createKML(r){
      console.log('https://cloud.citytocitymarket.com/_' + r.kml);
     this.kml = new google.maps.KmlLayer('https://cloud.citytocitymarket.com/_' + r.kml, {
          suppressInfoWindows: false,
          preserveViewport: true,
          map: this.map,
      });    
    }
  }
}
</script>
<style>
  .firstHeading {
    padding-bottom: 15px;
  }
  .bodyContent p {
    line-height: 10px;
  }
</style>





// WEBPACK FOOTER //
// src/components/mapping/business-listings.vue